//@ts-strict-ignore
import hasValidationErrors from '../../components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob } from '../../utils/BackgroundJobs';
import { getMutationProps, getRangeMutationProps } from '../sales/DocumentAction';
import { onDocumentComplete, onDocumentPrintFailed } from '../../utils/DocumentUtils';
import { SalesReturnNoteDocument } from '../../graphql/entities';
import { DocumentNode } from '@apollo/client';

function onComplete(state, props, job) {
  const { overrideOutput, outputType, showSummary } = state;
  const { dispatch, onClose, onComplete, onProcessSummary, onProcessPreview } = props;

  onDocumentComplete({
    overrideOutput,
    outputType,
    documentName: 'Return Note',
    documentNamePlural: 'Return Notes',
    dispatch,
    onClose: () => onClose(false, state, props, job),
    onComplete,
    showSummary,
    onProcessSummary: () => onProcessSummary(false, state, props, job),
    onProcessPreview,
    job,
  });
}

export function generate(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    SalesReturnNoteDocument.generate as DocumentNode,
    getMutationProps(state, props, variables, 'salesCredit'),
    props,
    returnUrl,
    'Print Return Note',
    (job) => onComplete(state, props, job)
  );
}

export function generateRange(state, props, variables, returnUrl, { rangeMutationProps }) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    SalesReturnNoteDocument.generateRange as DocumentNode,
    rangeMutationProps ||
      getRangeMutationProps(
        state,
        props,
        variables,
        'salesCredits',
        props.history.location.pathname.endsWith('/')
          ? props.history.location.pathname.slice(1, -1)
          : props.history.location.pathname.slice(1)
      ),
    props,
    returnUrl,
    'Generate Return Note Document',
    (job) => onComplete(state, props, job),
    (job) => onDocumentPrintFailed(state, props, job)
  );
}

export const printFunctions = {
  generate,
  generateRange,
};
